import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Bullet from 'components/prism/bullet';

export const Pathway = ({ text, pathway }) => {
    const { prismMultiColumn } = useSelector(state => state.ui);
    return (
        <>
            <h2 className="mb20">{text.title}</h2>
            <Link data-testid="pathway-item" to={`/develop/pathways?id=${pathway.id}`} className="prism-content-box">
                {prismMultiColumn && (
                    <div className="prism-banner">
                        <img src="/dist/img/defaults/pathway-default.jpg" />
                    </div>
                )}
                <div className="prism-content">
                    <Bullet type="pathway" />
                    <div className="prism-progress">
                        <div className="prism-progress-bar">
                            <div style={{ width: `${pathway.progress}%` }} />
                        </div>
                        <div>{pathway.progress}%</div>
                    </div>
                    <h3>{pathway.name}</h3>
                    {pathway.description && <p className="truncate-4">{pathway.description}</p>}
                    <button className="btn btn-primary mb10">{pathway.progress ? text.resume : text.start}</button>
                    <div className="split-col">
                        <Bullet isDate value={pathway.due} />
                        {pathway.duration > 0 && <Bullet isDuration value={pathway.duration / 60} />}
                    </div>
                </div>
            </Link>
        </>
    );
};

export default withRouter(Pathway);
